import React, { useState, useEffect } from 'react'
import './css/footer.css'
import { Link } from 'react-router-dom';
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from 'react';
import { openVolunteerPopup } from '../features/volunteerPopupSlice';
import { useDispatch } from 'react-redux';
import { createContactUs } from '../features/PublicAPIsService';

export default function Footer() {
    const dispatch = useDispatch();
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        // target: ref,
        offset: ["start end", "end start"]
    });
    const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

    const handleVolunteerClick = () => {
        dispatch(openVolunteerPopup());
    };

    const [formData, setFormData] = useState({
        name: "",
        phoneNumber: "",
        email: "",
        message: "",
    });

    const [agree, setAgree] = useState(false);
    const [responseMessage, setResponseMessage] = useState(null);
    const [messageType, setMessageType] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleFormChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    useEffect(() => {
        if (responseMessage) {
            const timer = setTimeout(() => {
                setResponseMessage(null);
                setMessageType("");
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [responseMessage]);

    const showMessage = (message, type) => {
        setResponseMessage(message);
        setMessageType(type);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setResponseMessage(null);
        setMessageType("");

        if (
            !formData.name.trim() ||
            !formData.email.trim() ||
            !formData.phoneNumber.trim() ||
            !formData.message.trim() ||
            !agree
        ) {
            showMessage("All fields are required", "error");
            setIsSubmitting(false);
            return;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            showMessage("Please enter a valid email address", "error");
            setIsSubmitting(false);
            return;
        }
        const phoneRegex = /^[0-9+\-\s]+$/;
        if (!phoneRegex.test(formData.phoneNumber) || formData.phoneNumber.replace(/[^0-9]/g, '').length < 10) {
            showMessage("Please enter a valid phone number (at least 10 digits)", "error");
            setIsSubmitting(false);
            return;
        }

        try {
            const res = await dispatch(
                createContactUs({
                    ...formData,
                    privacyAndPolicy: agree,
                })
            );

            if (res.payload?.success) {
                showMessage(res.payload.message || "Message sent successfully!", "success");
                setFormData({
                    name: "",
                    email: "",
                    phoneNumber: "",
                    message: "",
                });
                setAgree(false);
            } else {
                showMessage(res.payload?.message || "Something went wrong. Please try again.", "error");
            }
        } catch (error) {
            showMessage("Network error. Please check your connection.", "error");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <footer className="footer-main-section">
            

            <div className="customcontainer footer-grid">
                <div className="footer-left">
                    <h2 className="footer-title" data-aos="fade-up">
                        VEER SAMYAK<br />SANKALP INDIA
                    </h2>

                    <p className="footer-subtitle" data-aos="fade-up">
                  To convert pure intentions and inspired moments into legacies built on dedicated service and genuine impact.</p>

                    <div className="social-icons">
                        <span data-aos="fade-up">
                            <Link to="https://www.facebook.com/share/1C8k1cyVfV/">
                                <svg width="11" height="22" viewBox="0 0 11 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.04906 21.1601C5.81627 21.1601 4.71827 21.1601 3.62355 21.1601C3.07455 21.1601 3.13701 20.8115 3.13701 20.4695V13.4977C3.13701 12.5111 3.13701 12.5111 2.18694 12.5111C-0.114262 12.5111 -0.0156404 12.6328 0.00737168 10.3078C0.00737168 10.0874 0.00737168 9.8671 0.00737168 9.65005C0.0303837 8.87723 0.257214 8.64045 1.01661 8.62401C1.52945 8.62401 2.04558 8.5977 2.55513 8.62401C3.01537 8.65032 3.14687 8.44643 3.1403 8.01562C3.12386 6.91723 3.1403 5.81555 3.1403 4.72703C3.13595 4.10803 3.25424 3.49431 3.48834 2.9213C3.72243 2.34829 4.0677 1.82735 4.50418 1.38857C4.94066 0.949794 5.45972 0.601871 6.03138 0.364894C6.60304 0.127918 7.21596 0.00658486 7.83475 0.0079033C8.56785 0.0079033 9.30095 0.0079033 10.034 0.0079033C10.1567 -0.00944109 10.2816 0.0018518 10.3992 0.0408978C10.5167 0.0799439 10.6236 0.145682 10.7115 0.232963C10.7994 0.320243 10.8659 0.426695 10.9057 0.543978C10.9456 0.661261 10.9578 0.786189 10.9414 0.908976C10.9414 1.61931 10.9414 2.32636 10.9414 3.0367C10.9547 3.15366 10.9417 3.27213 10.9033 3.38341C10.8649 3.4947 10.8022 3.59598 10.7196 3.67985C10.637 3.76372 10.5367 3.82805 10.426 3.86813C10.3154 3.9082 10.1972 3.92301 10.0801 3.91146C9.59025 3.9279 9.09384 3.91146 8.61387 3.93119C8.41042 3.92635 8.20805 3.96238 8.01875 4.03714C7.82946 4.1119 7.65707 4.22388 7.51179 4.36646C7.36651 4.50903 7.25128 4.6793 7.17293 4.8672C7.09458 5.05509 7.0547 5.2568 7.05563 5.46039C7.01947 6.33844 7.05563 7.21978 7.0392 8.09126C7.0392 8.51878 7.22329 8.63717 7.6145 8.6273C8.3476 8.6273 9.08398 8.6273 9.81708 8.6273C10.5502 8.6273 10.8493 8.95616 10.7343 9.69609C10.6192 10.436 10.4581 11.0872 10.3201 11.7843C10.3067 11.8942 10.2717 12.0003 10.2171 12.0966C10.1625 12.1929 10.0894 12.2774 10.002 12.3453C9.91455 12.4131 9.81458 12.463 9.7078 12.4921C9.60103 12.5211 9.48957 12.5287 9.37985 12.5144C8.84071 12.5144 8.29828 12.5539 7.76572 12.5144C7.15754 12.4585 7.02604 12.7249 7.03262 13.2741C7.05563 15.5761 7.03262 17.8781 7.03262 20.1801L7.04906 21.1601Z" fill="var(--Footer-text-color)" />
                                </svg>
                            </Link>
                        </span>

                        <span data-aos="fade-up">
                            <Link to="https://www.instagram.com/veersamyaksankalp_/">
                                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="var(--Footer-text-color)">
                                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                    <g id="SVGRepo_iconCarrier">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z" fill="var(--Footer-text-color)"></path>
                                        <path d="M18 5C17.4477 5 17 5.44772 17 6C17 6.55228 17.4477 7 18 7C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5Z" fill="var(--Footer-text-color)"></path>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M1.65396 4.27606C1 5.55953 1 7.23969 1 10.6V13.4C1 16.7603 1 18.4405 1.65396 19.7239C2.2292 20.8529 3.14708 21.7708 4.27606 22.346C5.55953 23 7.23969 23 10.6 23H13.4C16.7603 23 18.4405 23 19.7239 22.346C20.8529 21.7708 21.7708 20.8529 22.346 19.7239C23 18.4405 23 16.7603 23 13.4V10.6C23 7.23969 23 5.55953 22.346 4.27606C21.7708 3.14708 20.8529 2.2292 19.7239 1.65396C18.4405 1 16.7603 1 13.4 1H10.6C7.23969 1 5.55953 1 4.27606 1.65396C3.14708 2.2292 2.2292 3.14708 1.65396 4.27606ZM13.4 3H10.6C8.88684 3 7.72225 3.00156 6.82208 3.0751C5.94524 3.14674 5.49684 3.27659 5.18404 3.43597C4.43139 3.81947 3.81947 4.43139 3.43597 5.18404C3.27659 5.49684 3.14674 5.94524 3.0751 6.82208C3.00156 7.72225 3 8.88684 3 10.6V13.4C3 15.1132 3.00156 16.2777 3.0751 17.1779C3.14674 18.0548 3.27659 18.5032 3.43597 18.816C3.81947 19.5686 4.43139 20.1805 5.18404 20.564C5.49684 20.7234 5.94524 20.8533 6.82208 20.9249C7.72225 20.9984 8.88684 21 10.6 21H13.4C15.1132 21 16.2777 20.9984 17.1779 20.9249C18.0548 20.8533 18.5032 20.7234 18.816 20.564C19.5686 20.1805 20.1805 19.5686 20.564 18.816C20.7234 18.5032 20.8533 18.0548 20.9249 17.1779C20.9984 16.2777 21 15.1132 21 13.4V10.6C21 8.88684 20.9984 7.72225 20.9249 6.82208C20.8533 5.94524 20.7234 5.49684 20.564 5.18404C20.1805 4.43139 19.5686 3.81947 18.816 3.43597C18.5032 3.27659 18.0548 3.14674 17.1779 3.0751C16.2777 3.00156 15.1132 3 13.4 3Z" fill="var(--Footer-text-color)"></path>
                                    </g>
                                </svg>
                            </Link>
                        </span>
                        <span data-aos="fade-up">
                            <Link to="https://www.youtube.com/channel/UCMguUeJTkQk_ipQvEU014iA">
                                <svg width="22" height="15" viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.5724 0C12.8736 0 15.1748 0 17.476 0C19.8364 0 21.1448 1.33188 21.1481 3.69967C21.1481 6.1113 21.1481 8.5328 21.1481 10.9642C21.1481 13.2366 19.8035 14.5816 17.5319 14.5816C12.8878 14.5816 8.2427 14.5816 3.59645 14.5816C1.3347 14.5816 0.00657487 13.2267 0 10.9642C0 8.52183 0 6.07622 0 3.62732C0 1.35819 1.31498 0.0263083 3.61618 0.00986537C5.9404 0.00986537 8.26133 0.00986537 10.5855 0.00986537L10.5724 0ZM8.2942 10.2472L14.2116 7.28752L8.2942 4.34752V10.2472Z" fill="var(--Footer-text-color)" />
                                </svg>
                            </Link>
                        </span>
                    </div>

                    <div className='footer-links-Div' data-aos="fade-up">

                        <div>
                            <div className="footer-pages">
                                <h4>Quick Links</h4>
                                <p><Link to='/'>Home</Link></p>
                                <p><Link to='/about-us'>About Us</Link></p>
                                <p><Link to='/contribute'>Contribute</Link></p>
                                <p><Link to='/connect'>Connect</Link></p>
                                <p><Link onClick={handleVolunteerClick}>Volunteer</Link></p>
                            </div>
                        </div>
                        
                        
                        <div>
                            <div className="footer-info">
                                <h4>Initiatives</h4>
                                <p><Link to='/initiative/faith-aalingan-sansthan'>Faith Aalingan Sansthan</Link></p>
                                <p><Link to='/initiative/humanity-welfare'>Humanity Welfare</Link></p>
                                <p><Link to='/initiative/retinoblastoma-treatment'>Retinoblastoma Treatment</Link></p>

                            </div>
                        </div>
                       
                    </div>
                </div>
                <div className="footer-up" data-aos="fade-up">
                    <form className="contact-form" onSubmit={handleSubmit}>
                        <input
                            type="text"
                            name="name"
                            placeholder="Name"
                            value={formData.name}
                            onChange={handleFormChange}
                            required
                        />
                        <input
                            type="email"
                            name="email"
                            placeholder="Email"
                            value={formData.email}
                            onChange={handleFormChange}
                            required
                        />

                        <input
                            type="tel"
                            name="phoneNumber"
                            placeholder="Phone"
                            value={formData.phoneNumber}
                            onChange={handleFormChange}
                            required
                        />
                        <textarea
                            placeholder="Message"
                            name="message"
                            value={formData.message}
                            onChange={handleFormChange}
                            required
                        ></textarea>

                        <label className="checkbox">
                            <input
                                type="checkbox"
                                checked={agree}
                                onChange={(e) => setAgree(e.target.checked)}
                                required
                            />
                            <span>
                                By submitting this form, I agree to the collection and use of my personal data as per Privacy Policy.
                            </span>
                        </label>
                        {responseMessage && (
                            <div className={`form-response ${messageType}`}>
                                <div className="message-content">
                                    <span className="message-icon">
                                        {messageType === "success" ? "✓" : "✕"}
                                    </span>
                                    <span className="message-text">{responseMessage}</span>
                                </div>
                            </div>
                        )}

                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className={isSubmitting ? 'loading' : ''}
                        >
                            <span className="btn-text">Send Message</span>
                            {isSubmitting && (
                                <div className="btn-loader-container">
                                    <span className="btn-loader"></span>
                                </div>
                            )}
                        </button>
                    </form>
                </div>
                <p className="footer-bottom">
                    © Veer Samyak Sankalp India | All Rights Reserved
                </p>
            </div>
        </footer>
    )
}